import { render, staticRenderFns } from "./PreOrderNoteHelp.vue?vue&type=template&id=0b54d1e4&scoped=true"
import script from "./PreOrderNoteHelp.vue?vue&type=script&lang=js"
export * from "./PreOrderNoteHelp.vue?vue&type=script&lang=js"
import style0 from "./PreOrderNoteHelp.vue?vue&type=style&index=0&id=0b54d1e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b54d1e4",
  null
  
)

export default component.exports